import gql from 'graphql-tag';

export const ARTICLES_FOR_AUTOCOMPLETE_QUERY = gql`
  query ArticlesForAutocompleteQuery($filter: AllArticlesFilterInput, $limit: Int) {
    allArticles(filter: $filter, limit: $limit) {
      edges {
        node {
          id
          url
          title
          activePerformanceRule {
            id
          }
        }
      }
    }
  }
`;
